import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { RestApiService } from '../angular-service/helper.httpServices';

@Injectable({
  providedIn: 'root',
})
export class MediaService {
  private endPoint =
    environment.wordPressApiUrl + environment.wordPressApiEndPoint;
  constructor(private http: RestApiService) {}

  getMedia(feature_media: String) {
    return new Promise((resolve, reject) => {
      if (feature_media) {
        this.http.get(this.endPoint + 'media/' + feature_media).subscribe(
          (response) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
      } else {
        console.log('error');
        reject('err');
      }
    });
  }
}
